import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { TypeItemServiceService } from 'src/app/services/type-item-servive/type-item-service.service';
import { Shop } from '../models/type/shop.model';
import { Type } from '../models/type/type.model';

@Component({
  selector: 'app-category',
  templateUrl: './category.page.html',
  styleUrls: ['./category.page.scss'],
})
export class CategoryPage implements OnInit {

  types: Type[] = [];
  // shops: Shop[] = [];
  shops = [];
  type: Type;
  shop: Shop;
  id: number;

  constructor(
    private typeServe: TypeItemServiceService,
    private shopService: ShopServiceService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {

    // this.shops = this.shopServe.getShops();
    this.shopService.getShops().subscribe((res) => {
      this.shops = res.map((shop) => {
        shop.payload.doc.data() as Shop;
      });
    });
    this.types = this.typeServe.getItems();
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
    this.type = this.typeServe.getTypeItem(this.id);

    this.types[0].active = false;
    this.types[1].active = false;
    this.types[2].active = false;
    this.types[3].active = false;

    this.types[this.id - 1].active = true;
  }

  goToCategory(id: number){

    if(id === 1){
      this.router.navigate(['home/landing']);
    }

    if(id > 1){
      this.router.navigate(['home/category', id]);
    }
  }

}
